import React, { useState } from "react";
import Wizard from "../components/user-wizard";
import styled from "@emotion/styled";
import { UserWizardObj } from "../types";

const Container = styled.div`
    width: 100%;
    min-height: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    padding: 2rem 1rem 0rem 1rem;
    margin: 0 auto;
`;

interface Props {}

const UserWizard = (props: Props) => {
    const [user, setUser] = useState<UserWizardObj>({
        initialContacts: [],
        mobileNotifications: true,
        emailNotifications: true,
        locationPermission: true,
        syncContacts: false,
    });

    return (
        <Container>
            <Wizard userObject={user} setUserObject={setUser} />
        </Container>
    );
};

export default UserWizard;
